export default __webpack_public_path__ + "static/media/Sun.37ec3dc7.svg";